import axios from 'axios';
import Vue from 'vue';
import router from '../router';
 
//Posworld API
Vue.$version = 'v6.2.510';
Vue.$isPosworld = false;

//Vue.$urlAPI =  "http://localhost:52616/api/"; 
//Vue.$urlAPI =  "https://posworldfrontoffice.azurewebsites.net/apidata/api/"; 

//  Vue.$urlCDN = "https://posworldshopcdn.azurewebsites.net/";  Staat in main.js !
//  Vue.$urlCDN =  "https://cdn.posworld.be/"; 

//Salonworld API
//Vue.$urlAPI =  "http://localhost:26311/api/";  //Sw
Vue.$urlAPI =  "https://onlineresapi.afsprakenboek.be/api/"; 

Vue.$tokenAPI = localStorage.getItem("usertoken");
Vue.$domain   = window.location.hostname;

const myHttpApi =  axios.create({
  baseURL: Vue.$urlAPI
});

myHttpApi.interceptors.request.use(function (config) {
  // Do something before request is sent
  config.headers.common['MyToken'] = Vue.$tokenAPI;
  config.headers.common['MyDomain'] = Vue.$domain;
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

myHttpApi.interceptors.response.use(function(response) {
  return response;
}, function(error) {

    if (error.response == undefined)
    {
       //console.log ("api error 1 :" + error);
       //alert (error);
       //router.push('/login');
    }
    else
    {
      if (error.response.status === 401) {
        //router.push('/login');
      }
      else if (error.response.status === 406) {
        //Wordt verder in app opgevangen.. custom melding..
      }
      else  {
        //console.log ("api error 1 :" + error);
        //alert (error);
        //router.push({ path: 'Error' })
//        router.push({ path: 'Error' })
      }
    }
    router.push({ path: 'Error' })
    //throw error;
  
});

export default myHttpApi;



// WEBPACK FOOTER //
// ./src/api/myhttpapi.js